import {
  GET_OVERVIEW_TABLE_DATA,
  SET_SEARCH_DATA,
  SET_SELECTED_DATA,
  SET_LOCK_TO_DO_FILTER,
  GET_OVERVIEW_SUMMARY_COUNT,
  GET_OVERVIEW_CARD_DETAILS,
  SET_USER_TYPE_FILTER,
  SET_USER_FILTER,
  SET_TODO_FILTER,
  GROUPED_BY_FILTER,
  GET_SINGLE_CARD_DETAILS,
  SET_NOTIFICATION_DATA_FOR_OVERVIEW_SCREEN,
} from "../constants";
import { ApiCall } from "../../utils/index";
import { Collaborator, Customer } from "../../constant/AuthenticationConstant";
import { downloadExcel } from "../../utils/index";
import axios from "axios";

export const getOverviewTableData =
  (status, search, page, pageSize, sort_by, sort_order, isLocked, request) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token, type },
      } = getState();
      const searchParam = search ? `search=${search}` : "";
      let params = `?${searchParam}&status=${JSON.stringify(
        status
      )}&page=${page}&pageSize=${pageSize}&sort_by=${sort_by}&sort_order=${sort_order}&isLocked=${isLocked}`;
      if (type === Customer || type === Collaborator) {
        params += `&type=${type}`;
      }

      const result = await ApiCall.get(
        `/activityAssignmentMapping/user${params}`,
        token
      );

      dispatch({ type: GET_OVERVIEW_TABLE_DATA, payload: result });
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

export const getNewOverviewTableData =
  (
    status,
    search,
    page,
    pageSize,
    sort_by,
    sort_order,
    isLocked,
    request,
    userTypeFilter,
    userFilter,
    todoFilter,
    groupedByFilter,
    start_date,
    end_date
  ) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token, type },
      } = getState();
      const searchParam = search ? `search=${search}` : "";
      let params = `?${searchParam}&status=${JSON.stringify(
        status
      )}&page=${page}&pageSize=${pageSize}&sort_by=${sort_by}&sort_order=${sort_order}&isLocked=${isLocked}&booking_groups=${groupedByFilter}`;

      if (type === Customer || type === Collaborator) {
        params += `&type=${type}s`;
      }

      if (start_date && end_date) {
        params += `&from_date=${start_date}&to_date=${end_date}`;
      }

      if (userTypeFilter?.type) {
        params += `&type=${userTypeFilter.type}`;
        if (
          (userTypeFilter?.type === "customers" ||
            userTypeFilter?.type === "collaborators") &&
          userFilter
        ) {
          if (userFilter?.length > 0) {
            const ids = userFilter.map((item) => item.value);
            params += `&ids=${JSON.stringify(ids)}`;
          }
        } else if (userTypeFilter?.type === "teams") {
          const ids = [userTypeFilter.value];
          params += `&ids=${JSON.stringify(ids)}`;
          if (userFilter?.length > 0) {
            const userIds = userFilter.map((item) => item.value);
            params += `&team_user_ids=${JSON.stringify(userIds)}`;
          }
        }
      }

      if (todoFilter?.length > 0) {
        const todo_ids = todoFilter.map((item) => item.value);
        params += `&todo_ids=${JSON.stringify(todo_ids)}`;
      }

      const result = await ApiCall.get(`/overview/todo${params}`, token);

      const data =
        result.data.length > 10 ? result.data.splice(0, 50) : result.data;

      const tempresult = {
        ...result,
        data: data,
      };

      dispatch({ type: GET_OVERVIEW_TABLE_DATA, payload: tempresult });
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

export const getNotificationDataForOverview =
  (
    status,
    search,
    page,
    pageSize,
    sort_by,
    sort_order,
    isLocked,
    request,
    userTypeFilter,
    userFilter,
    todoFilter,
    groupedByFilter
  ) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token, type },
      } = getState();
      const searchParam = search ? `search=${search}` : "";
      let params = `?${searchParam}&status=${JSON.stringify(
        status
      )}&page=${page}&pageSize=${pageSize}&sort_by=${sort_by}&sort_order=${sort_order}&isLocked=${isLocked}&booking_groups=${groupedByFilter}`;

      if (type === Customer || type === Collaborator) {
        params += `&type=${type}s`;
      }

      if (userTypeFilter?.type) {
        params += `&type=${userTypeFilter.type}`;
        if (
          (userTypeFilter?.type === "customers" ||
            userTypeFilter?.type === "collaborators") &&
          userFilter
        ) {
          if (userFilter?.length > 0) {
            const ids = userFilter.map((item) => item.value);
            params += `&ids=${JSON.stringify(ids)}`;
          }
        } else if (userTypeFilter?.type === "teams") {
          const ids = [userTypeFilter.value];
          params += `&ids=${JSON.stringify(ids)}`;
          if (userFilter?.length > 0) {
            const userIds = userFilter.map((item) => item.value);
            params += `&team_user_ids=${JSON.stringify(userIds)}`;
          }
        }
      }

      if (todoFilter?.length > 0) {
        const todo_ids = todoFilter.map((item) => item.value);
        params += `&todo_ids=${JSON.stringify(todo_ids)}`;
      }

      const result = await ApiCall.get(`/overview/todo${params}`, token);

      dispatch({ type: SET_NOTIFICATION_DATA_FOR_OVERVIEW_SCREEN, payload: result.data });
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

export const exportOverviewTableData =
  (
    status,
    search,
    page,
    pageSize,
    sort_by,
    sort_order,
    isLocked,
    userTypeFilter,
    userFilter,
    todoFilter,
    groupedByFilter,
    start_date,
    end_date
  ) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token, type },
      } = getState();
      const searchParam = search ? `search=${search}` : "";
      let params = `?${searchParam}&status=${JSON.stringify(
        status
      )}&page=${page}&pageSize=${pageSize}&sort_by=${sort_by}&sort_order=${sort_order}&isLocked=${isLocked}&booking_groups=${groupedByFilter}`;

      if (type === Customer || type === Collaborator) {
        params += `&type=${type}s`;
      }

      if (start_date && end_date) {
        params += `&from_date=${start_date}&to_date=${end_date}`;
      }

      if (userTypeFilter?.type) {
        params += `&type=${userTypeFilter.type}`;
        if (
          (userTypeFilter?.type === "customers" ||
            userTypeFilter?.type === "collaborators") &&
          userFilter
        ) {
          if (userFilter?.length > 0) {
            const ids = userFilter.map((item) => item.value);
            params += `&ids=${JSON.stringify(ids)}`;
          }
        } else if (userTypeFilter?.type === "teams") {
          const ids = [userTypeFilter.value];
          params += `&ids=${JSON.stringify(ids)}`;
          if (userFilter?.length > 0) {
            const userIds = userFilter.map((item) => item.value);
            params += `&team_user_ids=${JSON.stringify(userIds)}`;
          }
        }
      }

      if (todoFilter?.length > 0) {
        const todo_ids = todoFilter.map((item) => item.value);
        params += `&todo_ids=${JSON.stringify(todo_ids)}`;
      }

      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}/overview/export${params}`,
        {
          authorization: `Bearer ${token}`,
          responseType: "blob", // Important: ensures the response is treated as a binary file
        }
      );

      downloadExcel(result, "Overview");
    } catch (error) {
      console.log("overview api occurred ----", error);
    }
  };

export const setSearch = (searchData) => (dispatch) => {
  dispatch({ type: SET_SEARCH_DATA, payload: searchData });
};

export const setLockToDoFilter = (filterData) => (dispatch, getState) => {
  dispatch({ type: SET_LOCK_TO_DO_FILTER, payload: filterData });
};

export const setSelected = (selectedData) => (dispatch) => {
  dispatch({ type: SET_SELECTED_DATA, payload: selectedData });
};

export const setSelectedFilter = (selectedData) => (dispatch) => {
  dispatch({ type: SET_USER_TYPE_FILTER, payload: selectedData });
};

export const setSelectedUserFilter = (selectedData) => (dispatch) => {
  dispatch({ type: SET_USER_FILTER, payload: selectedData });
};

export const setSelectedToDoFilter = (selectedData) => (dispatch) => {
  dispatch({ type: SET_TODO_FILTER, payload: selectedData });
};

export const setGroupedByFilter = (selectedData) => (dispatch) => {
  dispatch({ type: GROUPED_BY_FILTER, payload: selectedData });
};

export const transferActivityRequest =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post(
        "/request/transfer_activity",
        request.body,
        token
      );
      request.onSuccess(result.data);
    } catch (error) {
      request.onError();
    }
  };

export const sendBackToAdminRequest =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post("/request/create", request.body, token);
      request.onSuccess(result.data);
    } catch (error) {
      request.onError();
    }
  };

export const extendActivityRequest =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post("/request/create", request.body, token);
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

export const getOverviewSummaryCount =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token, type },
      } = getState();
      let params = "";
      if (type === Customer || type === Collaborator) {
        params = `?type=${type}`;
      }
      const result = await ApiCall.get(
        `/activityAssignmentMapping/summary/user${params}`,
        token
      );

      dispatch({ type: GET_OVERVIEW_SUMMARY_COUNT, payload: result });
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

/* --------------------- Actions For My Overview -------------------- */
export const addOverviewCard = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.post(
      "/overview/cards",
      request.payload,
      token
    );

    request.onSuccess();
  } catch (error) {
    request.onError(
      error?.message
        ? error?.message
        : "Something went wrong. Please try again later."
    );
  }
};

export const getOverviewCardDetails =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get("/overview/cards", token);
      dispatch({ type: GET_OVERVIEW_CARD_DETAILS, payload: result.data });
    } catch (error) {
      request.onError("Something went wrong, please try again later.");
    }
  };

export const updateOverviewCard = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.put("/overview/cards", request.payload, token);
  } catch (error) {
    console.log(error);
  }
};

export const deleteOverviewCard = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.delete(
      `/overview/cards/${request.overview_card_id}`,
      token
    );
    request.onSuccess();
  } catch (error) {
    console.log("error while deleting ---", error);
  }
};

export const getSingleOverviewCardDetails =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/overview/cards/bookings/${request.overview_card_id}`,
        token
      );
      dispatch({ type: GET_SINGLE_CARD_DETAILS, payload: result.data });
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

  export const addOverviewNotification = (request) => async (dispatch, getState) => {
    try {
      const {auth : {token}} = getState();

      let url = "/overview/send_notifications";
      if(request.status) url = `${url}?status=${request.status}`;
      await ApiCall.post(url, request.payload, token);
      request.onSuccess();
    } catch (error) {
      request.onError(error)
    }
  }
